module.exports = __webpack_public_path__ + "img/chamada-form-video.231c77ee.png";